var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationHandearth = function SvgSimpleIllustrationHandearth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "simple-illustration__handearth_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 68 68"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".simple-illustration__handearth_svg__st1{fill:none;stroke:#002140;stroke-width:1;stroke-linecap:round;stroke-linejoin:round}.simple-illustration__handearth_svg__st3{fill:#5cdba3}.simple-illustration__handearth_svg__st4{fill:none;stroke:#002140;stroke-width:.9999;stroke-linecap:round;stroke-linejoin:round}")), /*#__PURE__*/React.createElement("path", {
    d: "M5.3 60.4s-.9 2.1 1.1 2.1h14.5s.5 0 1-.6 5.7-8.4 5.7-8.4.8-.6 1.4-.6h15.7s1.5-1.1 1.3-2.3h2.5s1.5-1 1.1-2.4l1.4-.4s1.3-.8 1.1-1.5c-.1-.8-1.3-1.8-1.8-1.8H48s.4-2.5-2.1-2.6c-2.5-.1-24.9 0-24.9 0l3.1-7.6s-.5-1.6-1.6-1.5c-1.1.1-1.9 1.1-1.9 1.1L5.3 60.4z",
    style: {
      fill: "#906630"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__handearth_svg__st1",
    d: "M28.6 52.8h15.6c.9 0 1.7-.8 1.7-1.7 0-.9-.8-1.7-1.7-1.7h-12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__handearth_svg__st1",
    d: "M46 50.5h2c.9 0 1.7-.8 1.7-1.7s-.8-1.7-1.7-1.7H36.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__handearth_svg__st1",
    d: "M49.7 47.9h.7c.9 0 1.7-.8 1.7-1.7 0-.9-.8-1.7-1.7-1.7H38.5M47.9 44.4c.1-.3.2-.5.2-.9 0-.9-.8-1.7-1.7-1.7H21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__handearth_svg__st1",
    d: "m20.3 43 3.4-7.4s.9-2-.4-2.6c-1.4-.7-2.1.2-2.5.9-2.7 4.4-12.4 20.6-15.6 26.8-.5.9.2 2 1.2 2h14.5c.5 0 .9-.2 1.2-.6l5.4-8.6c.2-.4.7-.6 1.2-.6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.8 37.1c8.1 0 14.7-6.6 14.7-14.7S49.9 7.6 41.8 7.6C33.6 7.6 27 14.2 27 22.4s6.6 14.7 14.8 14.7z",
    style: {
      fill: "#0180ff"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__handearth_svg__st3",
    d: "M33.5 34.9s3.4-2.1 4-3c.6-.9.8-5 3.2-5.5s9.2 1.4 10.1-1.9c1-3.3-2.2-5.5-2.2-5.5s-2.5-2.4-2.1-3.3c.5-1 1.9-5.4 1-6.2-1-.8-5.7-1.7-5.7-1.7s-9.7-1.4-14.3 8.1c-4.6 9.3 2.9 17.7 6 19zM48.4 30s-5.2 2.1-5.7 3.3c-.5 1.3-1 3.8-1 3.8s7.6-1.4 9-3c1.4-1.6 4.1-6.7 4.1-6.7s-4-.1-6.4 2.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__handearth_svg__st4",
    d: "M41.1 37.2c8.3 0 15.1-6.8 15.1-15.1S49.4 7 41.1 7 26 13.8 26 22.1s6.8 15.1 15.1 15.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__handearth_svg__st4",
    d: "M45.5 7.7c1.2.6 2.5 1.4 2.8 2.7.6 2.3-2.4 4.6-1.5 6.8.5 1.3 2 1.7 3 2.7 1.1 1 1.4 2.7.9 4.1-.5 1.4-1.9 2.4-3.4 2.5-1.4.1-2.8-.7-4.2-.7-1.8-.1-3.6 1.1-4.3 2.8-.3.7-.4 1.6-.7 2.3-.7 2-2.6 3.6-4.7 3.9M41.9 36.6c.1-2.8 2.3-5.4 5-6 .5-.1 1.1-.2 1.5-.4.5-.3.9-.7 1.3-1.1 1.4-1.4 3.5-2 5.4-1.8"
  })));
};
export default SvgSimpleIllustrationHandearth;